module.exports = __webpack_public_path__ + "static/media/tom2.7c6ad71b.jpg";